import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=6fa9254a&scoped=true&"
import script from "./SideBarItem.vue?vue&type=script&lang=ts&"
export * from "./SideBarItem.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=6fa9254a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa9254a",
  null
  
)

export default component.exports